<template>
  <button
    type="button"
    class="widget-fold-button"
    :class="{ 'is-folded': folded }"
    :aria-expanded="folded ? 'false' : 'true'"
    :title="label"
    :aria-label="label"
    @click="$emit('toggle')"
  >
    <i class="fas fa-chevron-down"></i>
  </button>
</template>

<script>
export default {
  name: "widget-fold-button",

  props: {
    folded: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.folded
        ? this.$t("COMMON.UNFOLD_WIDGET")
        : this.$t("COMMON.FOLD_WIDGET");
    },
  },
};
</script>

<style lang="scss">
.widget-fold-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  margin: -0.25rem 0.5rem -0.25rem -0.5rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font-size: 0.875rem;
  vertical-align: middle;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    box-shadow: 0 0 0 2px #5e72e4;
  }

  i {
    transition: transform 0.2s ease;
  }

  &.is-folded i {
    transform: rotate(-90deg);
  }
}

// A folded widget is reduced to its header.
.card.widget-folded > .card-header {
  border-bottom: 0 !important;
  border-radius: inherit;

  &.pb-0 {
    padding-bottom: 1.25rem !important;
  }
}
</style>
